import Navigation from './modules/Navigation.js';
import MobileNavigation from './modules/MobileNavigation.js';
import Modal from './modules/Modal.js';
import PaginationScroll from './modules/PaginationScroll.js';

document.addEventListener('DOMContentLoaded', function() {
  Navigation();
  MobileNavigation();
  Modal();
  PaginationScroll();
});
